import { queryKeyFactory } from "@l2r-front/l2r-query"

export const IMAGE_COLLECTION_ROOT_QUERY_KEY = "imageCollection"

export const imageCollectionQueryKeys = queryKeyFactory(IMAGE_COLLECTION_ROOT_QUERY_KEY, {
    photo: (filters = {}) => [IMAGE_COLLECTION_ROOT_QUERY_KEY, "photo", filters] as const,
})
